const DOLLAR_SCALE = 100;

export function centsToDollars(cents: number): string {
  return (Math.round(cents) / DOLLAR_SCALE).toFixed(2);
}

export function dollarsToCents(dollars: number): number {
  return Math.round(dollars * DOLLAR_SCALE);
}

export function isInCents(value: unknown): value is number {
  return typeof value === 'number' && Number.isFinite(value) && Number.isSafeInteger(value);
}

export function isInDollars(value: unknown): value is number {
  if (typeof value !== 'number' || !Number.isFinite(value)) {
    return false;
  }

  const shifted = value * DOLLAR_SCALE;
  return Math.abs(shifted - Math.round(shifted)) === 0;
}
